<template>
  <div class="container container-fluid row">
    <div v-if="showComponentData">
      <div class="row">
        <h4>Fotos vidrios</h4>
        <!-- PARABRISAS DELANTERO -->
        <div v-if="isFieldVisible('photo_glasses_front_windshield_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_glasses_front_windshield_file" class="form-label text-left">{{ getFieldDescription('photo_glasses_front_windshield_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_glasses_front_windshield_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_glasses_front_windshield_file'"
                  :id="'photo_glasses_front_windshield_file'"
                  style="display: none;"
                  @change="onFileChange('photo_glasses_front_windshield_file')"
                />
              </div>
            </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="photo_glasses_front_windshield_file" @click="openImageModal(photo_glasses_front_windshield_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- PARABRISAS TRASERO -->
        <div v-if="isFieldVisible('photo_glasses_back_windshield_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_glasses_back_windshield_file" class="form-label text-left">{{ getFieldDescription('photo_glasses_back_windshield_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_glasses_back_windshield_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_glasses_back_windshield_file'"
                  :id="'photo_glasses_back_windshield_file'"
                  style="display: none;"
                  @change="onFileChange('photo_glasses_back_windshield_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_glasses_back_windshield_file" @click="openImageModal(photo_glasses_back_windshield_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- VIDRIOS LARERAL IZQUIERDO -->
        <div v-if="isFieldVisible('photo_glasses_side_left_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_glasses_side_left_file" class="form-label text-left">{{ getFieldDescription('photo_glasses_side_left_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_glasses_side_left_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_glasses_side_left_file'"
                  :id="'photo_glasses_side_left_file'"
                  style="display: none;"
                  @change="onFileChange('photo_glasses_side_left_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_glasses_side_left_file" @click="openImageModal(photo_glasses_side_left_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- VIDRIOS LATERAL DERECHO -->
        <div v-if="isFieldVisible('photo_glasses_side_right_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_glasses_side_right_file" class="form-label text-left">{{ getFieldDescription('photo_glasses_side_right_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_glasses_side_right_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_glasses_side_right_file'"
                  :id="'photo_glasses_side_right_file'"
                  style="display: none;"
                  @change="onFileChange('photo_glasses_side_right_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_glasses_side_right_file" @click="openImageModal(photo_glasses_side_right_file)">Ver Imagen</div>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
    
  <!-- MODAL -->
  <ShowImagesModal
  :modalId="'imageModalPhotoGlases'"
  :currentImage="currentImage"
  :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js';
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';

export default {
  name: 'FormPhotoGlases',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_glasses_front_windshield_file = ref(null);
    const photo_glasses_back_windshield_file = ref(null);
    const photo_glasses_side_left_file = ref(null);
    const photo_glasses_side_right_file = ref(null);

    const formData = ref({
      photo_glasses_front_windshield_id: null,
      photo_glasses_back_windshield_id: null,
      photo_glasses_side_left_id: null,
      photo_glasses_side_right_id: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.photo_glasses_front_windshield_file ||
            dataCompany.value.photo_glasses_back_windshield_file ||
            dataCompany.value.photo_glasses_side_left_file ||
            dataCompany.value.photo_glasses_side_right_file)
        );
      } catch (error) {
        console.error(error);
      }
    };


    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoGlases').modal('show');
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_glasses_front_windshield_file: photo_glasses_front_windshield_file,
        photo_glasses_back_windshield_file: photo_glasses_back_windshield_file,
        photo_glasses_side_left_file: photo_glasses_side_left_file,
        photo_glasses_side_right_file: photo_glasses_side_right_file,
      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      const formFields = {
        photo_glasses_front_windshield_id: photo_glasses_front_windshield_file.value,
        photo_glasses_back_windshield_id: photo_glasses_back_windshield_file.value,
        photo_glasses_side_left_id: photo_glasses_side_left_file.value,
        photo_glasses_side_right_id: photo_glasses_side_right_file.value,
      };

      const validFields = {};
      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '_file')]) {
          validFields[key] = value;
        }
      }

      formData.value = validFields;
      emit('formDataChanged', formData.value);
    };

    const openCamera = async (fieldName) => {
      try {
        const inputElement = document.getElementById(fieldName);
        inputElement.click();
      } catch (error) {
        console.error('Error al abrir la ventana de selección de archivo:', error);
      }
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      formData,
      photo_glasses_front_windshield_file,
      photo_glasses_back_windshield_file,
      photo_glasses_side_left_file,
      photo_glasses_side_right_file,
      openCamera,
    };
  },
};
</script>

